module.exports = {
  "country": "BE",
  "artist": "Sandra Kim",
  "song": "J'aime la vie",
  "year": "1986",
  "place": "1",
  "spotify": "5opXus6JIe9UD94Qk24RYB"
};